export default "__VITE_ASSET__Drb6ZqVS__"